import { ICrewData, IYachtData } from "./ApiCalls";

export class LocalStorage {
    private static readonly _LOCAL_STORAGE_SELECTED_AUTH_USER = 'MarisAPP::AuthUser'; // Who is logged in
    private static readonly _LOCAL_STORAGE_SELECTED_CREW = 'MarisAPP::Crew';
    private static readonly _LOCAL_STORAGE_SELECTED_CREW_CARDS = 'MarisAPP::CrewCards';
    private static readonly _LOCAL_STORAGE_SELECTED_POS = 'MarisAPP::NavPos';
    private static readonly _LOCAL_STORAGE_SELECTED_NAV = 'MarisAPP::Nav';
    private static readonly _LOCAL_STORAGE_SELECTED_USER = 'MarisAPP::User';
    private static readonly _LOCAL_STORAGE_SELECTED_USER_PS_MR = 'MarisAPP::User::PS::MR';
    private static readonly _LOCAL_STORAGE_SELECTED_USER_PS_BC = 'MarisAPP::User::PS::BC';
    private static readonly _LOCAL_STORAGE_SELECTED_USER_PS_CR = 'MarisAPP::User::PS::CR';
    private static readonly _LOCAL_STORAGE_SELECTED_USER_CURRENCY = 'MarisAPP::UserCurrency';
    private static readonly _LOCAL_STORAGE_SELECTED_YACHT = 'MarisAPP::Yacht';
    private static readonly _LOCAL_STORAGE_SELECTED_YACHT_CURRENCIES = 'MarisAPP::YachtCurrencies';
    private static readonly _LOCAL_STORAGE_USER_EMAIL = 'MarisAPP::UserEmail';
    // private static readonly _LOCAL_STORAGE_TOKEN = 'MarisAPP::UserToken';
    // private static readonly _LOCAL_STORAGE_TOKEN_EXPIRES = 'MarisAPP::UserTokenExipres';
    // private static readonly _LOCAL_STORAGE_USER = 'MarisAPP::UserName';
    // private static readonly _LOCAL_STORAGE_USER_LEVEL = 'MarisAPP::UserLevel';
    // private static readonly _priceHistoryPurgeTTL = 24 * 3600 * 1000; //24h
    // private static readonly _priceHistoryDisplayTTL = 1 * 3600 * 1000; //1h

    static get authUser(): ICrewData | null {
        const user = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_AUTH_USER);
        if (user) {
            return JSON.parse(user);
        }
        return null;
    }

    static set authUser(newUser: ICrewData | null) {
        console.log('LocalStorage.setAuthUser:', this.authUser);
        if (newUser !== null) {
            localStorage.setItem(this._LOCAL_STORAGE_SELECTED_AUTH_USER, JSON.stringify(newUser));
            return;
        }
        localStorage.removeItem(this._LOCAL_STORAGE_SELECTED_AUTH_USER);
    }

    static get crew(): ICrewData[] {
        const crew = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_CREW);
        if (!crew) {
            return [];
        }
        return JSON.parse(crew);
    }

    static set crew(newCrew: ICrewData[]) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_CREW, JSON.stringify(newCrew));
    }

    static get crewCards(): ICrewData[] {
        const crew = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_CREW_CARDS);
        if (!crew) {
            return [];
        }
        return JSON.parse(crew);
    }

    static set crewCards(newCrew: ICrewData[]) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_CREW_CARDS, JSON.stringify(newCrew));
    }

    // static get eMail(): string | null {
    //     return localStorage.getItem(this._LOCAL_STORAGE_USER_EMAIL);
    // }

    // static set eMail(newKey: string | null) {
    //     if (newKey !== null) {
    //         localStorage.setItem(this._LOCAL_STORAGE_USER_EMAIL, newKey);
    //         return;
    //     }
    //     localStorage.removeItem(this._LOCAL_STORAGE_USER_EMAIL);
    // }

    static get pageSizeMissingReceipts(): number {
        const size = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_USER_PS_MR);
        if (size) {
            return parseInt(size);
        }
        return 25;
    }

    static set pageSizeMissingReceipts(newPageSize: number) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_USER_PS_MR, newPageSize.toString());
    }

    static get pageSizeBoatCash(): number {
        const size = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_USER_PS_BC);
        if (size) {
            return parseInt(size);
        }
        return 25;
    }

    static set pageSizeBoatCash(newPageSize: number) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_USER_PS_BC, newPageSize.toString());
    }

    static get pageSizeConfirmedReceipts(): number {
        const size = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_USER_PS_CR);
        if (size) {
            return parseInt(size);
        }
        return 25;
    }

    static set pageSizeConfirmedReceipts(newPageSize: number) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_USER_PS_CR, newPageSize.toString());
    }

    static get yacht(): IYachtData | null {
        const yacht = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_YACHT);
        if (yacht) {
            return JSON.parse(yacht);
        }
        return null;
    }

    static set yacht(newYacht: IYachtData | null) {
        console.log('LocalStorage.setYacht:', this.yacht);
        if (newYacht !== null) {
            localStorage.setItem(this._LOCAL_STORAGE_SELECTED_YACHT, JSON.stringify(newYacht));
            return;
        }
        localStorage.removeItem(this._LOCAL_STORAGE_SELECTED_YACHT);
    }

    static get yachtCurrencies(): string[] {
        const yachtCurrencies = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_YACHT_CURRENCIES);
        if (yachtCurrencies) {
            return JSON.parse(yachtCurrencies);
        }
        return [];
    }

    static set yachtCurrencies(newYachtCurrencies: string[]) {
        console.log('LocalStorage.setYachtCurrencies:', this.yachtCurrencies);
        if (newYachtCurrencies !== null) {
            localStorage.setItem(this._LOCAL_STORAGE_SELECTED_YACHT_CURRENCIES, JSON.stringify(newYachtCurrencies));
            return;
        }
        localStorage.removeItem(this._LOCAL_STORAGE_SELECTED_YACHT_CURRENCIES);
    
    }

    static get user(): ICrewData | null {
        const user = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_USER);
        if (user) {
            return JSON.parse(user);
        }
        return null;
    }

    static set user(newUser: ICrewData | null) {
        console.log('LocalStorage.setUser:', this.user);
        if (newUser !== null && newUser !== undefined) {
            localStorage.setItem(this._LOCAL_STORAGE_SELECTED_USER, JSON.stringify(newUser));
            return;
        }
        localStorage.removeItem(this._LOCAL_STORAGE_SELECTED_USER);
    }

    static get userCurrency(): string {
        return localStorage.getItem(this._LOCAL_STORAGE_SELECTED_USER_CURRENCY) ?? 'EUR';
    }

    static set userCurrency(newCurrency: string) {
        console.log('LocalStorage.setUser:', this.user);
        if (newCurrency !== null) {
            localStorage.setItem(this._LOCAL_STORAGE_SELECTED_USER_CURRENCY, newCurrency);
            return;
        }
        localStorage.removeItem(this._LOCAL_STORAGE_SELECTED_USER_CURRENCY);
    }

    static get nav(): number {
        const nav = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_NAV);
        if (nav) {
            return parseInt(nav);
        }
        return 0;
    }

    static set nav(newNav: number) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_NAV, newNav.toString());
    }

    static get navPos(): number {
        const nav = localStorage.getItem(this._LOCAL_STORAGE_SELECTED_POS);
        if (nav) {
            return parseInt(nav);
        }
        return 0;
    }

    static set navPos(newPos: number) {
        localStorage.setItem(this._LOCAL_STORAGE_SELECTED_POS, newPos.toString());
    }

    // static get apiKey(): string | null {
    //     return localStorage.getItem(this._LOCAL_STORAGE_TOKEN);
    // }

    // static set apiKey(newKey: string | null) {
    //     if (newKey === null) {
    //         localStorage.removeItem(this._LOCAL_STORAGE_TOKEN);
    //         localStorage.removeItem(this._LOCAL_STORAGE_TOKEN_EXPIRES);
    //         localStorage.removeItem(this._LOCAL_STORAGE_USER);
    //         return;
    //     }
    //     localStorage.setItem(this._LOCAL_STORAGE_TOKEN, newKey);
    // }

    // static set user(newUser: string | null) {
    //     if (newUser === null) {
    //         localStorage.removeItem(this._LOCAL_STORAGE_USER);
    //         return;
    //     }
    //     localStorage.setItem(this._LOCAL_STORAGE_USER, newUser);
    // }

    // static set tokenExpires(expires: string) {
    //     localStorage.setItem(this._LOCAL_STORAGE_TOKEN_EXPIRES, expires);
    // }
}
